import { Card, Typography } from 'antd';
import moment from 'moment/moment';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Utils from 'utils/utils';

import { CounterofferButton } from './CounterofferButton';

import { ICounterofferButton } from 'models';

import styles from './index.module.scss';
import { Link } from 'react-router-dom';

type CounterofferCardProps = {
	date: string;
	title: string;
	rows: { title: string; value: string; isText?: boolean }[];
	buttons: ICounterofferButton[];
	id: number;
};

export const CounterofferCard: FC<CounterofferCardProps> = ({ date, title, rows, id, buttons }) => {
	const { t } = useTranslation();

	date = moment(new Date(date)).format('YYYY-MM-DD');

	return (
		<Card className={styles.root}>
			<div className={styles.header}>
				<div>
					{t('projectText')}:&nbsp;
					<Link className={styles.link} to={`/account/projects/${id}`}>
						{title}
					</Link>
				</div>
				<div>
					{t('offerDateText')}: {date}
				</div>
			</div>
			<div className={styles.content}>
				{rows.map((item) => (
					<CounterofferRow key={item.title} {...item} />
				))}
			</div>
			<div className={styles.footer}>
				{buttons.map((item) => (
					<CounterofferButton key={item.text} {...item} text={t(item.text)} />
				))}
			</div>
		</Card>
	);
};

const CounterofferRow = ({ title, isText, value }: any) => {
	const { t } = useTranslation();

	return (
		<div className={styles.row}>
			<Typography.Text type="secondary">{t(title)}</Typography.Text>
			<Typography.Text className={styles.value}>
				{isText ? t(value) : Utils.moneyFormat(+value)}
			</Typography.Text>
		</div>
	);
};
